import React from "react";
import HeaderItem from "./HeaderItem";

export default function Header() {
  return (
    <>
      <div className="back--header">
        <HeaderItem
          link = "link white"
          burgerLine = "burger-line"
        />
      </div>
    </>
  )
}